import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
const { proxy } = require('../../ip_api.config')

class Acc_EditItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            isLoading: false,
            arr_item: [],
            arr_check: [],
            arr_show: [],
            arr_save: [],
        }
    }

    componentDidMount() {
        if (localStorage.getItem("ID_User") !== null) {
            this.setState({
                id: this.props.location.state.id_edit
            }, () => {
                this.push_arrItemSave()
            })
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    push_arrItemSave = () => {
        this.setState({ isLoading: true })
        let arr = []
        let temp
        let url = proxy.server + '/acc/get_Viewitem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.id
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    let data = {
                        item_no: val.ItemId,
                        description: val.SearchName,
                        production_location: val.ItemBuyerGroupId === 'CN' ? 'จีน'
                        : val.ItemBuyerGroupId === 'CN-FAC' ? 'Difu/สังขละ' : val.ItemBuyerGroupId === 'TH' ? 'ไทย' : '',
                        pack_location: val.PurchInventLocationId === 'WRM' ? 'จีน' : 'ไทย' ,
                        type1: val.ItemId.charAt(0),
                        brand: '',
                        item_g1: val.ECL_ItemCategoryIdG1,
                        item_g2: val.ECL_ItemCategoryIdG2,
                        item_g3: val.ECL_ItemCategoryIdG3,
                        item_g4: val.ECL_ItemCategoryIdG4,
                        ibrand1: val.ECL_ItemCategoryIdBrand1,
                        ibrand2: val.ECL_ItemCategoryIdBrand2,
                        ibrand3: val.ECL_ItemCategoryIdBrand3,
                        ibrand4: val.ECL_ItemCategoryIdBrand4,
                        poduct_type: val.DefaultOrderType,
                        type2: val.ItemGroupId,
                        category: val.ItemGroupId === 'FG' ? 'Finished Goods'
                        : val.ItemGroupId === 'HP' ? 'SEMI Pack Oversea'
                            : val.ItemGroupId === 'SM' ? 'Semi Product'
                                : val.ItemGroupId === 'PK' ? 'Packaging'
                                    : val.ItemGroupId === 'SU' ? 'Supply'
                                        : val.ItemGroupId === 'RM' ? 'Raw Material'
                                            : val.ItemGroupId === 'WF' ? 'Voucher'
                                                : val.ItemGroupId === 'FS' ? 'Factory Supply'
                                                    : val.ItemGroupId === 'FA' ? 'Fixed Assets'
                                                        : val.ItemGroupId === 'SV' ? 'Service item' : '',
                        cost_group_id: val.ItemId === '01' || val.ItemId === '03' ? 'PM' : 'MT',
                        unit: val.InventTableModulePurch_UnitId,
                        additional: val.InventTableModulePurch_OverDeliveryPct,
                        item_buyer: val.ItemBuyerGroupId,
                        item_disc_group: val.InventTableModuleSales_LineDisc,
                        production: val.ECL_NumberSequenceGroupProd,
                        cost_group: val.DefaultDimension,
                        invent_buy: val.PurchInventLocationId,
                        invent_collect: val.ItemInventLocationId,
                        invent_sale: val.SalesInventLocationId,
                        image: val.image,
                        db_name: val.db_name
                    }

                    arr.push(data)
                })
                temp = this.state.arr_save.concat(arr)
                this.setState({ arr_save: temp, responseJson: arr }, () => { this.getItem_Preview() })
            })
    }

    getItem_Preview = () => {
        let arr = []

        this.state.responseJson.map(function (val, i) {
            console.log(this.state.arr_save[i])
            let type1 = this.state.arr_save[i] === undefined ? val.item_no.charAt(0) : this.state.arr_save[i].item_no.charAt(0)

            let brand = this.state.arr_save[i] === undefined ? val.item_no.substr(1, 2) : this.state.arr_save[i].item_no.substr(1, 2)

            let item_g1 = this.state.arr_save[i] === undefined ? val.item_no.substr(0, 3) : this.state.arr_save[i].item_no.substr(0, 3)

            let item_g2 = this.state.arr_save[i] === undefined
                ? val.item_no.charAt(0) === 'P' || val.item_no.charAt(0) === 'U' ? val.item_no.charAt(4) : val.item_no.substr(3, 2)
                : this.state.arr_save[i].item_no.charAt(0) === 'P' || this.state.arr_save[i].item_no.charAt(0) === 'U' ? this.state.arr_save[i].item_no.charAt(4) : this.state.arr_save[i].item_no.substr(3, 2)

            let item_g3 = this.state.arr_save[i] === undefined
                ? val.item_no.charAt(1) + val.item_no.charAt(2) === '04'
                    ? ''
                    : val.item_no.charAt(0) === 'U' ? '02'
                        : val.item_no.charAt(0) === 'P' ? '01'
                            : val.item_no.substr(5, 2)
                : this.state.arr_save[i].item_no.charAt(1) + this.state.arr_save[i].item_no.charAt(2) === '04'
                    ? ''
                    : this.state.arr_save[i].item_no.charAt(0) === 'U' ? '02'
                        : this.state.arr_save[i].item_no.charAt(0) === 'P' ? '01'
                            : this.state.arr_save[i].item_no.substr(5, 2)

            let item_g4 = this.state.arr_save[i] === undefined
                ? val.item_no.charAt(0) === 'G' || val.item_no.charAt(0) === 'H' || val.item_no.charAt(0) === 'S'
                    ? item_g1 + item_g2 + item_g3
                    : item_g1 + '-' + item_g2 + item_g3
                : this.state.arr_save[i].item_no.charAt(0) === 'G' || this.state.arr_save[i].item_no.charAt(0) === 'H' || this.state.arr_save[i].item_no.charAt(0) === 'S'
                    ? item_g1 + item_g2 + item_g3
                    : item_g1 + '-' + item_g2 + item_g3

            let type2 = type1 === 'G' ? 'FG' : type1 === 'H' ? 'HP' : type1 === 'S' ? 'SM' : type1 === 'P' ? 'PK' : type1 === 'U' ? 'SU' : 0
            let product_type = type2 === 'FG' || type2 === 'HP' || type2 === 'SM' ? 'Production' : 'Purchase Order'
            let category = type2 === 'FG' ? 'Finished Goods'
            : type2 === 'HP' ? 'SEMI Pack Oversea'
                : type2 === 'SM' ? 'Semi Product'
                    : type2 === 'PK' ? 'Packaging'
                        : type2 === 'SU' ? 'Supply'
                            : type2 === 'RM' ? 'Raw Material'
                                : type2 === 'WF' ? 'Voucher'
                                    : type2 === 'FS' ? 'Factory Supply'
                                        : type2 === 'FA' ? 'Fixed Assets'
                                            : type2 === 'SV' ? 'Service item' : ''
            let cost_group_id = item_g3 === '01' || item_g3 === '03' ? 'PM' : 'MT'
            let additional = type2 === 'SM' ? '2' : type2 === 'PK' || type2 === 'SU' ? '10' : ''
            let item_buyer = type1 === 'G' || type1 === 'H' ? ''
                : this.state.arr_save[i] !== undefined ? this.state.arr_save[i].production_location === 'จีน' ? 'CN'
                    : this.state.arr_save[i].production_location === 'Difu' || this.state.arr_save[i].production_location === 'สังขละ' ? 'CN-FAC' : 'TH' : ''
            let item_disc_group = this.state.arr_save[i] !== undefined ? type1 === 'G' ? this.state.arr_save[i].ibrand2 : '' : ''
            let production = this.state.arr_save[i] !== undefined ? this.state.arr_save[i].production_location === 'สังขละ' ? 'PD-ABS' : 'PD-PACK' : ''
            let cost_group = brand === '01' || brand === '02' ? 'PG01' : 'PG03'
            let invent_buy = type1 === 'G' || type1 === 'H' ? 'WRM'
                : this.state.arr_save[i] !== undefined ? this.state.arr_save[i].pack_location === 'จีน' ? 'WRM'
                    : brand === '09' || brand === '04' ? 'WRM'
                        : item_g2 === '41' ? 'WRM' : 'SRM' : ''
            let invent_collect = 'WRM'
            let invent_sale = type1 === 'G' ? 'W1T' : ''

            arr.push(
                <tr>
                    <td>
                        <bs4.Col sm='12' style={{ width: 160 }}>
                            <bs4.Input type="select" name="db_name" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.db_name}>{val.db_name}</option>
                                <option value="DPL">DPL</option>
                                <option value="DFIX">DFIX</option>
                                <option value="DPT">DPT</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 240 }}>
                            <bs4.Input type="text" name="item_no" onChange={(e) => e.target.value.length > 20 ? alert('ห้ามกรอกเกิน 20 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.item_no} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 240 }}>
                            <bs4.Input type="textarea" name="description" onChange={(e) => e.target.value.length > 60 ? alert('ห้ามกรอกเกิน 60 ตัวอักษร') : this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.description} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 160 }}>
                            <bs4.Input type="select" name="production_location" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.production_location}>{val.production_location}</option>
                                <option value="Difu">Difu</option>
                                <option value="สังขละ">สังขละ</option>
                                <option value="ไทย">ไทย</option>
                                <option value="จีน">จีน</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 140 }}>
                            <bs4.Input type="select" name="pack_location" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.pack_location}>{val.pack_location}</option>
                                <option value="ไทย">ไทย</option>
                                <option value="จีน">จีน</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td style={{ fontWeight: 600 }}>{type1}</td>
                    <td style={{ fontWeight: 600 }}>{brand}</td>
                    <td style={{ fontWeight: 600 }}>{item_g1}</td>
                    <td style={{ fontWeight: 600 }}>{item_g2}</td>
                    <td style={{ fontWeight: 600 }}>{item_g3}</td>
                    <td style={{ fontWeight: 600 }}>{item_g4}</td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="select" name="ibrand1" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.ibrand1}>{val.ibrand1}</option>
                                <option value="Powermax">Powermax</option>
                                <option value="Why">Why</option>
                                <option value="Rizz">Rizz</option>
                                <option value="Bewell">Bewell</option>
                                <option value="Cube">Cube</option>
                                <option value="iFox">iFox</option>
                                <option value="China">China</option>
                                <option value="OEM">OEM</option>
                                <option value="License">License</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="text" name="ibrand2" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} defaultValue={val.ibrand2} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="select" name="ibrand3" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.ibrand3}>{val.ibrand3}</option>
                                <option value="Line">Line</option>
                                <option value="Paul Frank">Paul Frank</option>
                                <option value="Goriha">Goriha</option>
                                <option value="Sanrio">Sanrio</option>
                                <option value="Marvel">Marvel</option>
                                <option value="Cable_ECO">Cable_ECO</option>
                                <option value="Cable_Normal">Cable_Normal</option>
                                <option value="Cable_Pro">Cable_Pro</option>
                                <option value="Cable_High">Cable_High</option>
                                <option value="None">None</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 200 }}>
                            <bs4.Input type="select" name="ibrand4" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.ibrand4}>{val.ibrand4}</option>
                                <option value="Line">Line</option>
                                <option value="Paul Frank">Paul Frank</option>
                                <option value="Goriha">Goriha</option>
                                <option value="Kitty">Kitty</option>
                                <option value="My Melody">My Melody</option>
                                <option value="Badz Badz Maru">Badz Badz Maru</option>
                                <option value="Gudetama">Gudetama</option>
                                <option value="Spiderman">Spiderman</option>
                                <option value="Ironman">Ironman</option>
                                <option value="Captain America">Captain America</option>
                                <option value="None">None</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td style={{ fontWeight: 600 }}>{product_type}</td>
                    <td style={{ fontWeight: 600 }}>{type2}</td>
                    <td style={{ fontWeight: 600 }}>{category}</td>
                    <td style={{ fontWeight: 600 }}>{cost_group_id}</td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 140 }}>
                            <bs4.Input type="select" name="unit" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)}>
                                <option value={val.unit}>{val.unit}</option>
                                <option value="G">G</option>
                                <option value="KG">KG</option>
                                <option value="PAIR">PAIR</option>
                                <option value="PCS">PCS</option>
                                <option value="LITE">LITE</option>
                            </bs4.Input>
                        </bs4.Col>
                    </td>
                    <td style={{ fontWeight: 600 }}>{additional}</td>
                    <td style={{ fontWeight: 600 }}>{item_buyer}</td>
                    <td style={{ fontWeight: 600 }}>{item_disc_group}</td>
                    <td style={{ fontWeight: 600 }}>{production}</td>
                    <td style={{ fontWeight: 600 }}>{cost_group}</td>
                    <td style={{ fontWeight: 600 }}>{invent_buy}</td>
                    <td style={{ fontWeight: 600 }}>{invent_collect}</td>
                    <td style={{ fontWeight: 600 }}>{invent_sale}</td>
                    <td> <bs4.Col sm='12' style={{ width: 250 }}><bs4.Input type="file" name="image" /></bs4.Col></td>
                </tr>
            )
        }, this)
        this.setState({ previewItem: arr, isLoading: false })
    }

    handleChangeItem = (index, name, value) => {
        if (name === 'db_name') {
            this.state.arr_save[index].db_name = value
        } else if (name === 'production_location') {
            this.state.arr_save[index].production_location = value

            let item_buyer = this.state.arr_save[index].type1 === 'G' || this.state.arr_save[index].type1 === 'H' ? ''
                : this.state.arr_save[index] !== undefined ? this.state.arr_save[index].production_location === 'จีน' ? 'CN'
                    : this.state.arr_save[index].production_location === 'Difu' || this.state.arr_save[index].production_location === 'สังขละ' ? 'CN-FAC' : 'TH' : ''
            this.state.arr_save[index].item_buyer = item_buyer

            let production = this.state.arr_save[index] !== undefined ? this.state.arr_save[index].production_location === 'สังขละ' ? 'PD-ABS' : 'PD-PACK' : ''
            this.state.arr_save[index].production = production
        } else if (name === 'pack_location') {
            this.state.arr_save[index].pack_location = value

            let invent_buy = this.state.arr_save[index].type1 === 'G' || this.state.arr_save[index].type1 === 'H' ? 'WRM'
                : this.state.arr_save[index] !== undefined ? this.state.arr_save[index].pack_location === 'จีน' ? 'WRM'
                    : this.state.arr_save[index].brand === '09' || this.state.arr_save[index].brand === '04' ? 'WRM'
                        : this.state.arr_save[index].item_g2 === '41' ? 'WRM' : 'SRM' : ''
            this.state.arr_save[index].invent_buy = invent_buy

        } else if (name === 'ibrand1') {
            this.state.arr_save[index].ibrand1 = value
        } else if (name === 'ibrand2') {
            this.state.arr_save[index].ibrand2 = value

            let item_disc_group = this.state.arr_save[index] !== undefined ? this.state.arr_save[index].type1 === 'G' ? this.state.arr_save[index].ibrand2 : '' : ''
            this.state.arr_save[index].item_disc_group = item_disc_group
        } else if (name === 'ibrand3') {
            this.state.arr_save[index].ibrand3 = value
        } else if (name === 'ibrand4') {
            this.state.arr_save[index].ibrand4 = value
        } else if (name === 'unit') {
            this.state.arr_save[index].unit = value
        } else if (name === 'description') {
            this.state.arr_save[index].description = value
        } else if (name === 'item_no') {
            this.state.arr_save[index].item_no = value

        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.getItem_Preview()
        })
    }

    update_item = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/acc/update_item'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: this.state.id,
                    arr: this.state.arr_save
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false })
                        this.props.history.push({
                            pathname: '/Acc/PreviewItem'
                        })
                    } else {
                        this.setState({ isLoading: false })
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Acc'} menu={'Acc_EditItem'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 20 }} >EDIT ITEM</bs4.Label>
                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.update_item()}>SAVE</bs4.Button>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#8f8f8f', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>ฐานข้อมูล</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Item No.</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Description</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>ผลิตที่</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>สถานที่แพ็ค</th>
                            <th>Type</th>
                            <th>Brand</th>
                            <th>Item G1</th>
                            <th>Item G2</th>
                            <th>Item G3</th>
                            <th>Item G4</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Ibrand 1</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Ibrand 2</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Ibrand 3</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Ibrand 4</th>
                            <th>ประเภทสินค้า</th>
                            <th>Type</th>
                            <th>Category</th>
                            <th>Cost Group ID</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>Unit</th>
                            <th>%Additional</th>
                            <th>Item Buyer</th>
                            <th>Item Disc Group</th>
                            <th>Production</th>
                            <th>Cost Group</th>
                            <th>คลังซื้อ</th>
                            <th>คลังจัดเก็บ</th>
                            <th>คลังขาย</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>image</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewItem}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Acc_EditItem